<template>
  <div>
    <ConversionAreaOne
      v-if="product"
      v-bind="{
        product,
        addOn,
        agreementCategory,
        isAdjusted,
        injectedVideo,
        productReference,
        showBenefits,
        showPaypalHint,
        showRating,
        showSizeAttentionText,
        showSizeTable,
        sizeTableButtonText,
        showVariantPriceDifference,
      }"
    />
    <ConversionAreaWithProvider
      v-else-if="shopifyHandle"
      v-bind="{
        shopifyHandle,
        agreementCategory,
        isAdjusted,
        injectedVideo,
        productReference,
        showBenefits,
        showPaypalHint,
        showRating,
        showSizeAttentionText,
        showSizeTable,
        sizeTableButtonText,
        showVariantPriceDifference,
      }"
    />
  </div>
</template>

<script lang="ts" setup>
import ConversionAreaOne from './ConversionAreaOne.vue';
import ConversionAreaWithProvider from './ConversionAreaWithProvider.vue';

defineProps({
  product: {
    type: Object,
    default: () => null,
  },
  addOn: {
    type: Object,
    default: () => null,
  },
  agreementCategory: {
    type: Array,
    default: () => null,
  },
  isAdjusted: {
    type: Boolean,
    default: false,
  },
  shopifyHandle: {
    type: String,
    default: null,
  },
  injectedVideo: {
    type: Object,
    default: () => ({}),
  },
  productReference: {
    type: Array,
    default: () => [],
  },
  showBenefits: {
    type: Boolean,
    default: true,
  },
  showPaypalHint: {
    type: Boolean,
    default: true,
  },
  showRating: {
    type: Boolean,
    default: true,
  },
  showSizeAttentionText: {
    type: Boolean,
    default: false,
  },
  showSizeTable: {
    type: Boolean,
    default: false,
  },
  sizeTableButtonText: {
    type: String,
    default: null,
  },
  showVariantPriceDifference: {
    type: Boolean,
    default: false,
  },
});
</script>
